<div class="content-wrapper">
  <coin-a-navigation-menu [disableNavigationLink]="disableNavigationLink()"></coin-a-navigation-menu>
  <div class="content">
    <ng-content></ng-content>
  </div>
</div>
